import React, { useEffect } from "react";
import { useParams } from "react-router";
import Banner from "../Components/banner/Banner";
import BannerData from "../models/BannersData";
import TitleComponent from "../Components/common/TitleComponent";
import TreatmentsData from "../models/TreatmentsData";
import TreatmentCard from "../Components/card/TreatmentCard";
import SubFooterBar from "../Components/common/SubFooterBar";
import BreadcrumbsComponent from "../Components/common/BreadcrumbsComponent";
import { Typography } from "@material-tailwind/react";
import Background1 from "../Components/background/Background1";

const TreatmentsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { Category } = useParams();

  const BreadCrumbsPath = Category
    ? [
      {
        id: 1,
        pathName: "Our Treatments",
        pathLink: "/Treatments",
      },
      {
        id: 2,
        pathName: `${Category} Treatments`,
        pathLink: "",
      },
    ]
    : [
      {
        id: 1,
        pathName: "Our Treatments",
        pathLink: "/Treatments",
      },
    ];

  return (
    <>
      {BannerData.filter((item) => item.title === "Treatments").map((item) => (
        <Banner key={item.id} bannerDetails={item} Category={Category} />
      ))}

      <BreadcrumbsComponent fullWidth BreadCrumbsPath={BreadCrumbsPath} />

      {Category ? (
        <TitleComponent
          Title={`${Category} Treatments`}
          Subtitle={`Checkout our treatments for ${Category} here.`}
        />
      ) : (
        <TitleComponent
          Title={"Our Treatments"}
          Subtitle={"Checkout our treatments here."}
        />
      )}

      <div className="relative my-3">
        <Background1 />

        <div className="-mt-[95vh] py-5 px-5 md:px-12 lg:px-24 grid gap-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {Category
            ? TreatmentsData.filter(
              (item) => item.categoryName == Category
            ).map((item) => (
              <TreatmentCard key={item.id} treatmentDetails={item} />
            ))
            : TreatmentsData.map((item) => (
              <TreatmentCard key={item.id} treatmentDetails={item} />
            ))}
        </div>
      </div>

      <SubFooterBar />
    </>
  );
};

export default TreatmentsPage;
